import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Airborne sound insulation - Standardized impact sound pressure level L’nT",
  description: "Standardized  impact sound pressure level L’nT for averaged four source positions is shown.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/05/22/principle/principle-14.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
